import { interceptorMiddleware } from '../../../shared/services/interceptor.service';
import { createApi } from '@reduxjs/toolkit/query/react';
import {
    ApiParamEnum,
    HttpMethods,
} from '../../../shared/constants/application.constant';
import { apiUrlSubAdmin } from '../constants/apiUrl.adminUsers';
import { CreateSubAdminRequest, SubAdmin } from '../constants/types.adminUsers';
import { ListResponse } from '../../../shared/utils/types.elements';
import { ConstNumber } from '../../../shared/constants/number.constant';

// Define a service using a base URL and expected endpoints
export const subAdminApi = createApi({
    reducerPath: 'subAdmin',
    baseQuery: interceptorMiddleware,
    tagTypes: ['subAdmin'],
    endpoints: (builder) => ({
        createSubAdmin: builder.mutation({
            query: (data: CreateSubAdminRequest) => {
                return {
                    url: apiUrlSubAdmin.SUB_ADMIN,
                    method: HttpMethods.POST,
                    body: data,
                };
            },
        }),
        getSubAdmins: builder.query<ListResponse<SubAdmin>, { page: number }>({
            query: ({ page }) => ({
                url: `${apiUrlSubAdmin.SUB_ADMIN}?limit=${
                    ApiParamEnum.LIMIT
                }&offset=${(page - ConstNumber.VALUE_1) * ApiParamEnum.OFFSET}`,
                method: HttpMethods.GET,
            }),
            providesTags: ['subAdmin'],
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useCreateSubAdminMutation, useGetSubAdminsQuery } = subAdminApi;
